(ns frontend.view.settings2.web-form.submitter-guidance                                             ;; TODO: remove if not used
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [common.url :as url]
            [common.util :as cu]
            [frontend.logging :as logging]
            [frontend.state.current-session :as session]
            [frontend.tenant-customizations :as tenant-customizations]
            [frontend.view.settings2.web-form.events :as events]
            [reagent.core :as r]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn greeting-input
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/heading
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label     (loc/tr :webentry-greeting)
       :data-type :data.type/text-simple
       :value     old-value
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur   (fn [new-value]
                    (events/save-webform!
                     webentry
                     attribute
                     new-value
                     (fn [_]
                       (logging/info "Update successful!"))
                     (fn [err]
                       (logging/error "Failed to update " err))))}]]))

(defn welcome-text-input
  [{:keys [webentry]}]
  (let [attribute :webentry/heading-text
        old-value (get webentry attribute)]
    [labelled-input/view
     {:label     (loc/tr :webentry-welcome-text)
      :data-type :data.type/text-richtext
      :value     old-value
      :on-blur   (fn [value]
                   (let [value (if (cu/blank-value? value) "<p></p>" value)]
                     (events/save-webform!
                      webentry
                      attribute
                      value
                      (fn [_]
                        (logging/info "Update successful!"))
                      (fn [err]
                        (logging/error "Failed to update " err)))))}]))


(defn privacy-policy-input
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/privacy-policy
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label     (loc/tr :web-form-settings/privacy-policy)
       :data-type :data.type/text-url
       :value     (if (string/starts-with? "https://" old-value)
                    old-value
                    (url/prepend-protocol (str old-value) :https))
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur   (fn [new-value]
                    (events/save-webform!
                     webentry
                     attribute
                     new-value
                     (fn [_]
                       (logging/info "Update successful!"))
                     (fn [err]
                       (logging/error "Failed to update " err))))}]]))


(defn privacy-statement
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/privacy-statement
        old-value (get @entity-atom attribute)
        old-value (if (string/blank? old-value)
                    (loc/tr :webentry/confirmation-text [@session/tenant-name])
                    old-value)]
    [:div
     [labelled-input/view
      {:label     (loc/tr :web-form-settings/privacy-statement)
       :data-type :data.type/text-multiline
       :value     old-value
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur   (fn [new-value]
                    (events/save-webform!
                     webentry
                     attribute
                     new-value
                     (fn [_]
                       (logging/info "Update successful!"))
                     (fn [err]
                       (logging/error "Failed to update " err))))}]]))


(defn view
  [{:keys [_webentry _entity-atom]}]
  (let [state-atom (r/atom {})]
    (fn [{:keys [webentry entity-atom]}]
      [:div
       {:class "grid grid-cols-1 gap-4"}
       [:div
        [:div
         {:class "flex flex-col gap-4"}
         [:div
          [:div
           {:class "font-semibold text-xl"}
           "Submitter guidance"]]
         [:div
          [greeting-input
           {:webentry    webentry
            :entity-atom entity-atom
            :state-atom  state-atom}]]
         [:div
          [welcome-text-input
           {:webentry    webentry
            :entity-atom entity-atom
            :state-atom  state-atom}]]
         (when-not (tenant-customizations/innovestor?)
           [:div
            {:class "flex flex-col gap-4"}
            [:div
             [privacy-statement
              {:webentry    webentry
               :entity-atom entity-atom
               :state-atom  state-atom}]]
            [:div
             [privacy-policy-input
              {:webentry    webentry
               :entity-atom entity-atom
               :state-atom  state-atom}]]])]]])))
